import { render, staticRenderFns } from "./AgencyActionsCostsReadOnlyView.vue?vue&type=template&id=562e6e0f&scoped=true&"
import script from "./AgencyActionsCostsReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./AgencyActionsCostsReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./AgencyActionsCostsReadOnlyView.vue?vue&type=style&index=0&id=562e6e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562e6e0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VForm,VLayout})
